<template>
  <div>
    <el-image
      style="width: 80px; height: 80px; border-radius: 6px; object-fit: contain"
      :src="url"
      :preview-src-list="imageUrls"
      ref="preview"
    ></el-image>
    <!-- @mouseenter="enter" -->
    <!-- @mouseleave="out" -->
    <transition name="el-fade-in">
      <div class="mask" v-show="fadeShow">
        <!-- <i
          class="el-icon-zoom-in"
          style="
            font-size: 14px;
            color: #fff;
            text-align: center;
            font-weight: normal;
            cursor: pointer;
            position: absolute;
            left: 20%;
            top: 40%;
          "
          @click="lookImage"
        ></i> -->
        <i
          class="el-icon-delete"
          style="
            font-size: 14px;
            color: #F56C6C;
            text-align: center;
            font-weight: normal;
            cursor: pointer;
            position: absolute;
            left: 102%;
            top: 82%;
          "
          @click="deleteImage(ind)"
        ></i>
      </div>
    </transition>

    <div style="text-align: center">
      <el-image-viewer
        v-if="showViewer"
        :on-close="closeViewer"
        :url-list="imageUrls"
      ></el-image-viewer>
    </div>
  </div>
</template>

<script>
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
export default {
  components: { ElImageViewer },
  props: {
    url: {
      type: String,
    },
    imageUrls: {
      type: Array,
    },
    ind: {
      type: Number,
    },
  },
  watch: {
    imageUrls: {
      handler: function (val) {
        this.imageUrl = val;
      },
      deep: true,
      immediate: true,
    },
    ind: {
      handler: function (val) {
        this.index = val;
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      fadeShow: true,
      showViewer: false,
      imageUrl: [],
      index: 0,
    };
  },
  methods: {
    deleteImage() {
      this.imageUrl.splice(this.index, 1);
    },
    //查看照片的按钮
    // lookImage() {
    //   this.showViewer = true;
    // },
    //关闭图片预览
    closeViewer() {
      this.showViewer = false;
    },
    // enter() {
    //     console.log("进入")
    //   this.fadeShow = true;
    // },
    // out() {
    //     console.log("离开")
    //   this.fadeShow = false;
    // },
  },
};
</script>

<style scoped>
/* .mask {
  position: absolute;
  left: 0;
  top: 0;
  padding: 0;
  width: 148px;
  height: 148px;
  border-radius: 6px;
  background: rgba(0, 0, 0, 0.5);
} */
</style>
